import "date-fns";
import React from "react";
import Grid from "@material-ui/core/Grid";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

export default function CheckDate({ setCheck, check, method }) {
  // The first commit of Material-UI

  const handleDateChange = (date) => {
    if (date instanceof Date && !isNaN(date)) {
      setCheck({ ...check, datePaid: date.toISOString() });
    } else {
      console.log("Invalid date");
    }
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid
        container
        justifyContent="space-around"
        style={{ width: "97%", paddingLeft: "10px", paddingBottom: "15px" }}
      >
        <KeyboardDatePicker
          fullWidth
          disableToolbar
          variant="outline"
          format="MM/dd/yyyy"
          margin="normal"
          id="date-picker-inline"
          label=" Check Date "
          value={check.datePaid}
          onChange={handleDateChange}
          disabled={method.title === "Existing-Check"}
          KeyboardButtonProps={{
            "aria-label": "change date",
          }}
        />
      </Grid>
    </MuiPickersUtilsProvider>
  );
}
